import React, { useRef } from "react";
import { useSpring, useChain, animated } from "react-spring";
import { Typography } from "@mui/material";
import styled from "styled-components";

const smile = "M33 80C33 80 36.0508 91 48.2542 91C60.4576 91 63 80 63 80";
const flat = "M50 90C50 90 55.0625 91 68 91C80.9375 91 86 90 86 90";
const frown = "M50 113C50 113 54.9219 91 67.5 91C80.0781 91 85 113 85 113";

export const Go404Animation = React.memo(function Animation() {
    const leftCircleRef = useRef();
    const leftCircle = useSpring({
        from: { r: 15, cx: 48 },
        to: { r: 18, cx: 44 },
        ref: leftCircleRef
    });

    const rightCircleRef = useRef();
    const rightCircle = useSpring({
        from: { r: 15, cx: 86 },
        to: { r: 22, cx: 90 },
        ref: rightCircleRef
    });

    const leftLineRef = useRef();
    const leftLine = useSpring({
        from: { x1: 59, y1: 44, x2: 61, y2: 42 },
        to: { x1: 20, y1: 23, x2: 30, y2: 18 },
        ref: leftLineRef
    });

    const rightLineRef = useRef();
    const rightLine = useSpring({
        from: { x1: 59, y1: 44, x2: 61, y2: 42 },
        to: { x1: 90, y1: 10, x2: 100, y2: 15 },
        ref: rightLineRef
    });

    const curveRef = useRef();
    const curve = useSpring({
        config: { mass: 1, tension: 300, friction: 50 },
        from: { d: smile },
        to: [{ d: flat }, { d: frown }],
        ref: curveRef
    });

    const logoTitleRef = useRef();
    const logoTitle = useSpring({
        config: { mass: 1, tension: 300, friction: 50 },
        from: { opacity: 1 },
        to: { opacity: 0 },
        ref: logoTitleRef
    });

    useChain(
        [logoTitleRef, curveRef, leftLineRef, rightLineRef, leftCircleRef, rightCircleRef],
        // eslint-disable-next-line no-magic-numbers
        [1.5, 2, 2, 2, 3, 3]
    );

    return (
        <Container>
            <LogoTitle variant="h3" color="secondary">
                <animated.div style={logoTitle}>nucleus</animated.div>
            </LogoTitle>
            <svg
                width="130"
                height="130"
                viewBox="0 0 130 130"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <animated.circle cy="57" stroke="#F78F21" strokeWidth="6" {...leftCircle} />
                <animated.circle cy="57" stroke="#F78F21" strokeWidth="6" {...rightCircle} />
                <animated.line
                    stroke="#F78F21"
                    strokeWidth="6"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    {...leftLine}
                />
                <animated.line
                    stroke="#F78F21"
                    strokeWidth="6"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    {...rightLine}
                />
                <animated.path stroke="#F78F21" strokeWidth="6" strokeLinecap="round" {...curve} />
            </svg>
        </Container>
    );
});

const Container = styled.div`
    position: relative;
    margin-bottom: 2rem;
`;

const LogoTitle = styled(Typography)`
    margin: none;
    position: absolute;
    left: 50%;
    transform: translate(-50%);
    top: 5%;
`;
